import { StyleSheet, View, ViewProps } from 'react-native'
import { Button, Spacing } from 'zens-storybook'
import { useMemo } from 'react'
import { Draft, UserData, useUser } from 'zens-store'
import { useTranslation } from 'react-i18next'

import { Link } from 'zens-router'

import { NavigationConfirm } from '../navigation'

import UserRoleSelect from './roleselect'

const styles = StyleSheet.create({
  container: {},
  bottom: {
    marginTop: Spacing.L,
    flexDirection: 'row',
    marginHorizontal: -Spacing.XS,
    justifyContent: 'space-between',
  },
  bottomLeft: {
    flexDirection: 'row',
  },
  button: {
    marginHorizontal: Spacing.XS,
  },
})

interface Props extends ViewProps {
  companyId: number
  userId: number
  onSave?: (draft: Draft<UserData>) => void
}

const UserForm = (props: Props) => {
  const { companyId, userId, onSave, style, ...otherProps } = props
  const { t } = useTranslation()
  const user = useUser({ companyId, userId })
  const draft = useMemo(() => new Draft<UserData>({ id: userId, ...user.data?.data }), [user.data?.data])

  const updateRole = (roleId: number) => {
    draft.update('role_id', roleId)
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      {/* <View style={styles.block}>
          <UserLocation value={user.data?.locationId} />
        </View> */}
      <UserRoleSelect
        companyId={companyId}
        roleId={user.data?.roleId}
        value={draft.data?.role_id}
        onSelect={updateRole}
      />
      <View style={styles.bottom}>
        <View style={styles.bottomLeft}>
          <Button
            title={t('Save')}
            size="L"
            style={styles.button}
            onPress={() => onSave?.(draft)}
            testID="UserEdit.Save"
          />
          <Link href={`/companies/${companyId}/users`} asChild>
            <Button title={t('Cancel')} light size="L" style={styles.button} testID="UserEdit.Cancel" />
          </Link>
        </View>
      </View>
      <NavigationConfirm draft={draft} />
    </View>
  )
}

interface SkeletonProps extends ViewProps {}
const Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <UserRoleSelect.Skeleton />
      <View style={styles.bottom}>
        <View style={styles.bottomLeft}>
          <Button.Skeleton style={styles.button} />
          <Button.Skeleton style={styles.button} />
        </View>
      </View>
    </View>
  )
}
UserForm.Skeleton = Skeleton

export default UserForm
